import React, { useEffect, useState } from "react";
import {
  district,
  block,
  nWiseregionType,
  nWiseregionCode,
  selectedDYear,
  allSWiseregionType,
  allSWiseregionCode,
  specificSWiseregionType,
  allDWiseregionType,
  specificDWiseregionType,
  allBWiseregionType,
  specificBWiseregionType,
  nationalWiseName,
  stateWiseName,
  districtWiseName,
  blockWiseName,
  initialFilterSchoolData,
  initialFilterPtRData,
  intialStateWiseFilterSchData,
} from "../../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStateData,
  updateFilterState,
} from "../../../redux/thunks/stateThunk";
import {
  fetchDistrictDataByStateCode,
  removeAllDistrict,
  updateFilterDistrict,
} from "../../../redux/thunks/districtThunk";
import { fetchYearData } from "../../../redux/thunks/yearThunk";
import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import {
  updateUdiseBlockCode,
  updateUdiseDistrictCode,
} from "../../../redux/slice/DistBlockWiseSlice";
import {
  fetchBlockByDistrictCode,
  removeAllBlock,
  updateFilterBlock,
} from "../../../redux/thunks/blockThunk";
import { Select } from "antd";
import { useLocation, useParams } from "react-router-dom";

import {
  fetchArchiveServicesSchoolData,
  fetchArchiveServicesPieGraphSchoolData,
  fetchArchiveServicesGraphSchoolData,
  fetchArchiveServicesTeacherDataSocialCatGender,
  fetchArchiveServicesStudentData,
  fetchArchiveServicesPtR,
  fetchArchiveServicesStudentSummarisedData,
  fetchArchiveServicesStudentGPIStatsData,
  fetchArchiveServicesTeacherData,
  fetchArchiveServicesTeacherTrainingData,
  fetchArchiveServicesTeacherDisabilityData,
  fetchArchiveServicesProfileSchoolData,
  fetchArchiveServicesClassesTaughtData,
  fetchArchiveServicesPtRYearsManagementWise,
  fetchArchiveServicesCWSNEnrolmentData
} from "../../../redux/thunks/archiveServicesThunk";
import {
  fetchDashboardData,
  fetchSchoolStatsData,
  fetchTeachersStatsData,
  fetchStudentStatsData,
  fetchStudentStatsIntData,
  fetchSchoolStatsIntData,
  fetchTeachersStatsIntData,
  fetchAllStateSchemesData,
  fetchSchoolStatsDataYear,
  fetchSchoolProfileStatsData,
  fetchSchoolProfileDataYear
} from "../../../redux/thunks/dashboardThunk";
import {
  handleCurrentIndex,
  handleRegionName,
  handleShowDistrict,
  handleViewDataByShow,
  handleShowFilter,
  setReserveUpdatedFilter,
} from "../../../redux/slice/headerSlice";
import mapJsonData from "../../../mapData/mapDatalatLong.json";
import { setSelectedStateCode } from "../../../redux/slice/stateSlice";

import {
  updateMapData,
  updateMapLoaded,
  updateMapSession,
} from "../../../redux/slice/mapSlice";
export default function FilterDropdownCommom358({activeCatTab4010}) {
  ////console.log('activeCatTab4010', activeCatTab4010)
  const dispatch = useDispatch();
  const location = useLocation();
  const queryString = window.location.href;
  const urlParams = new URLSearchParams(queryString.replace("#/", ""));
  const paramValue = urlParams.get("type");
  const stateData = useSelector((state) => state.state);
  const headerSlice = useSelector((state) => state.header);
  const stateDataClone = useSelector((state) => state.state.dataClone);
  const yearData = useSelector((state) => state.year);
  const schoolFilter = useSelector((state) => state.schoolFilter);
  const districtData = useSelector((state) => state.distrct);
  const districtDataClone = useSelector((state) => state.distrct.dataClone);
  const blockData = useSelector((state) => state.block);
  const blockDataClone = useSelector((state) => state.block.dataClone);
  const headerData = useSelector((state) => state.header);
  const [isStateSelected, setIsStateSelected] = useState(false);
  const [selectedState, setSelectedState] = useState(nationalWiseName);
  const [selectedStateW, setSelectedStateW] = useState("State Wise");
  const [selectedDistrict, setSelectedDistrict] = useState(district);
  const [selectedDistrictclone, setSelectedDistrictClone] = useState(district);
  const [selectedYear, setSelectedYear] = useState(selectedDYear);
  const [selectedBlock, setSelectedBlock] = useState(block);
  const [selectedBlockClone, setSelectedBlockClone] = useState(block);
  const [isDashbtnDisabled, setIsDashbtnDisabled] = useState(true);
  const [is3016btnDisabled, setIs3016btnDisabled] = useState(true);
  const show = useSelector((state) => state.header.show);
  const distBlockWiseData = useSelector((state) => state.distBlockWise);
  let filterObj = structuredClone(schoolFilter);
  ////console.log('filterObj', filterObj)
  const [updateYearId, setUpdateYearId] = useState(filterObj.yearId);
  const reserveUpdatedFilter = useSelector(state => state.header.reserveUpdatedFilter);

  const selectedStateCode = useSelector((state) => state.state.selectedStateCode)


  //window.localStorage.setItem("state", selectedState);

  useEffect(() => {
    window.localStorage.setItem("state_wise", selectedStateW);
    window.localStorage.setItem("district", selectedDistrict);
    window.localStorage.setItem("block", selectedBlock);
    window.localStorage.setItem("year", selectedYear);
  }, [selectedState, blockData, stateData, districtData]);
  const mapStateValue = localStorage.getItem("map_state_name");
  const mapDisValue = window.localStorage.getItem("map_district_name");
  const mapBlockValue = window.localStorage.getItem("block");
  const mapYearValue = window.localStorage.getItem("year");
  const [jsonstateData, setJsonStateData] = useState([]);
  useEffect(() => {
    filterObj = structuredClone(schoolFilter);
  }, [schoolFilter]);

  useEffect(() => {
    setJsonStateData(mapJsonData.stateData);
    const queryString = window.location.href;
    const urlParams = new URLSearchParams(queryString.replace("#/", ""));
    const paramValue = urlParams.get("type");
    if (paramValue === "table") {
      dispatch(handleViewDataByShow(true));
    } else if (location.pathname === "/") {
      dispatch(handleViewDataByShow(true));
    } else {
      dispatch(handleViewDataByShow(false));
    }
  }, [mapJsonData.stateData]);

  useEffect(() => {
    dispatch(fetchStateData(filterObj.yearId));
    dispatch(fetchYearData());
    const children = document.getElementsByClassName("position-static");
    let filter_drodown = document.getElementsByClassName("filter_drodown")[0];
    if (children.length === 2) {
      filter_drodown?.classList?.add("small-filter-box");
    } else {
      filter_drodown?.classList?.remove("small-filter-box");
    }

    dispatch(allFilter(initialFilterSchoolData));
    const handleEvent = () => {
      // setShow(false);
      dispatch(handleShowFilter(false));
    };
    const targetElement = window.document.getElementById("content");
    targetElement.removeEventListener("click", handleEvent);
    targetElement.addEventListener("click", function (e) {
      handleEvent();
    });

    return () => {
      targetElement.removeEventListener("click", handleEvent);
    };
  }, []);

  const handleSchoolFilterYear = (e) => {
    const splittedArr = e.split("@");
    const year = parseInt(splittedArr[0]);
    const year_report = splittedArr[1];
    setSelectedYear(year_report);
    filterObj.yearId = year;
    // dispatch(allFilter(filterObj));
    setUpdateYearId(filterObj?.yearId);
    if (location.pathname !== "/") {
      filterObj.valueType = 1;
    } else {
      filterObj.valueType = 2;
    }

    const reserveUpdatedFilters = {
      ...reserveUpdatedFilter,
      yearId: year,
      valueType: location.pathname !== "/" ? 1 : 2,
    };
    dispatch(setReserveUpdatedFilter(reserveUpdatedFilters));
    if (mapStateValue === nationalWiseName || mapStateValue === stateWiseName) {
      handleAPICallAccordingToFilter(filterObj);
      handleAPICallAccordingToFilterShowpieGraph(filterObj)
    }
    else {
      // handleAPICallAccordingToFilterShow(filterObj);
      handleAPICallAccordingToFilter(reserveUpdatedFilters);
      handleAPICallAccordingToFilterShowpieGraph(reserveUpdatedFilters)

    }
    window.localStorage.setItem("year", year_report);
    hideOpendFilterBox();
  };

  const handleSchoolFilterState = (e) => {
    const splittedArr = e.split("@");
    console.log('state_name', splittedArr)
    const state_code = splittedArr[0];
    const state_name = splittedArr[1];
    const lat = splittedArr[2];
    const long = splittedArr[3];
    filterObj.yearId = updateYearId;

    setIsStateSelected(true);
    setSelectedState(state_name);
    setSelectedStateW(state_name);
    setSelectedDistrict(district);
    setSelectedBlock(block);
    setSelectedBlockClone(block);

    //
    dispatch(updateUdiseDistrictCode(state_code));
    dispatch(handleRegionName("States"));
    dispatch(setSelectedStateCode(state_code));
    dispatch(updateUdiseDistrictCode(state_code));
    dispatch(handleRegionName("States"));

    //
    /*--------------------Filter by National----------------------*/
    console.log('state_name', state_name)
    if (state_name === nationalWiseName) {
      // debugger
      sessionStorage.setItem("handle", "");
      filterObj.regionType = nWiseregionType;
      filterObj.regionCode = nWiseregionCode;
      filterObj.dashboardRegionType = 10;
      filterObj.dashboardRegionCode = "09";
      filterObj.dType = 10;
      filterObj.dCode = 99;
      filterObj.valueType = location.pathname !== "/" ? 1 : 2;
      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: nWiseregionType,
        regionCode: nWiseregionCode,
        dashboardRegionType: 10,
        dashboardRegionCode: "09",
        dType: 11,
        dCode: 11,
        valueType: selectedStateCode.valueType,
        valueType: location.pathname !== "/" ? 1 : 2,
        yearId: filterObj.yearId,
      };
      dispatch(setReserveUpdatedFilter(updatedFilterObj));

      console.log('location.pathname', location.pathname)
      dispatch(allFilter(filterObj));
      if (
          location.pathname === "/school-reports-1003" || 
          location.pathname === "/school-reports-1004" || 
          location.pathname === "/school-reports-1005" || 
          location.pathname === "/school-reports-1006"  || 
          location.pathname === "/school-reports-1007"  || 
          location.pathname === "/school-reports-1008"  || 
          location.pathname === "/school-reports-1009"  || 
          location.pathname === "/school-reports-1010"  || 
          location.pathname === "/school-reports-1011"  || 
          location.pathname === "/school-reports-1013"  || 
          location.pathname === "/school-reports-1014"  || 
          location.pathname === "/teacher-reports-2001" ||
          location.pathname === "/teacher-reports-2002" || 
          location.pathname === "/teacher-reports-2003" || 
          location.pathname === "/teacher-reports-2004" || 
          location.pathname === "/teacher-reports-2005" || 
          // location.pathname === "/teacher-reports-2007"  || 
          location.pathname === "/teacher-reports-2008" || 
          location.pathname === "/teacher-reports-2009" ||  
          location.pathname === "/teacher-reports-2010" ||  
          location.pathname === "/teacher-reports-2011" ||
          location.pathname === "/student-reports-4000" || 
          location.pathname === "/student-reports-4002" || 
          location.pathname === "/student-reports-4006" || 
          location.pathname === "/student-reports-4007" || 
          location.pathname === "/student-reports-4008" || 
          location.pathname === "/student-reports-4009" || 
          location.pathname === "/student-reports-4010" || 
          location.pathname === "/student-reports-4011" || 
          location.pathname === "/student-reports-4032" || 
          location.pathname === "/student-reports-4004" || 
          location.pathname === "/school-reports-2006"  
          
        
        ) {

        handleAPICallAccordingToFilter(filterObj);
        handleAPICallAccordingToFilterShow(filterObj);
      }
      if (headerData.activeTab === "table" && location.pathname === "/infrastructure-reports3013") {
        handleAPICallAccordingToFilter(filterObj);
        handleAPICallAccordingToFilterShow(filterObj);
      }
      handleAPICallAccordingToFilterShowpieGraph(filterObj)
      const elements = document.querySelectorAll(".impact-box-content.active");
      elements.forEach((element) => {
        element.classList.remove("active");
      });
      const disObj = {
        stateId: state_code,
        state_name: state_name,
        latitude: long,
        longitude: lat,
      };
      sessionStorage.setItem("state-map-details", JSON.stringify(disObj));

      dispatch(updateMapSession(disObj));
      dispatch(handleShowDistrict(false));
      dispatch(updateMapLoaded(false));
      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(district);
      const modifiedFilterObjs = {
        // regionCode: 99,
        regionCode: filterObj.regionCode,
        dCode: 99,
        regionType: 21,
        yearId: filterObj.yearId,
      };
      dispatch(fetchAllStateSchemesData(modifiedFilterObjs));
    } else if (state_name === stateWiseName) {
      const newDataObject = {
        yearId: filterObj.yearId,
        regionType: 10,
        regionCode: "99",
        dType: 10,
        dCode: 99,
        categoryCode: 0,
        managementCode: 0,
        locationCode: 0,
        schoolTypeCode: 0,
        dashboardRegionType: 11,
        dashboardRegionCode: 11,
        valueType: 2,
      };

      /*--------------------Filter by State Wise----------------------*/

      filterObj.regionType = allSWiseregionType;
      filterObj.regionCode = allSWiseregionCode;

      filterObj.dType = allSWiseregionType;
      filterObj.dCode = allSWiseregionCode;

      filterObj.dashboardRegionType = 11;
      filterObj.dashboardRegionCode = state_code;
      if (location.pathname !== "/") {
        filterObj.valueType = 1;
      } else {
        filterObj.valueType = 2;
      }

      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: allSWiseregionType,
        regionCode: allSWiseregionCode,
        dType: allSWiseregionType,
        dCode: allSWiseregionCode,
        dashboardRegionType: 11,
        dashboardRegionCode: state_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        yearId: filterObj.yearId,
      };

      dispatch(setReserveUpdatedFilter(updatedFilterObj));
      dispatch(allFilter(filterObj));

      if (location.pathname === "/") {
        handleAPICallAccordingToFilter(newDataObject);
        handleAPICallAccordingToFilterShow(newDataObject);
      } else {
        handleAPICallAccordingToFilter(filterObj);
        handleAPICallAccordingToFilterShow(filterObj);
      }

      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(district);
    } else {
      /*--------------------Filter by Particular State ----------------------*/
      /************ remove selected events *************/
      const elements = document.querySelectorAll(".impact-box-content.active");
      elements.forEach((element) => {
        element.classList.remove("active");
      });
      filterObj.regionType = specificSWiseregionType;
      filterObj.regionCode = state_code;

      filterObj.dType = 11;
      filterObj.dCode = state_code;

      filterObj.dashboardRegionType = 11;
      filterObj.dashboardRegionCode = state_code;
      if (location.pathname !== "/") {
        filterObj.valueType = 1;
      } else {
        filterObj.valueType = 2;
      }
      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: specificSWiseregionType,
        regionCode: state_code,
        dType: 11,
        dCode: state_code,
        dashboardRegionType: 11,
        dashboardRegionCode: state_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        yearId: filterObj.yearId,
      };

      dispatch(setReserveUpdatedFilter(updatedFilterObj));
      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      headerData.isViewDataByShow &&
        handleAPICallAccordingToFilterShow(filterObj);
      if (
        !headerData.isViewDataByShow &&
        location.pathname !== "/" &&
        location.pathname !== "/school-reports-1005" &&
        location.pathname !== "/school-reports-1003" &&
        location.pathname !== "/school-reports-1004"

      ) {
        const district_data = state_code + "@" + districtWiseName;
        handleSchoolFilterDistrict(district_data);
        if (location.pathname === "/infrastructure-reports3013") {
          filterObj.dCode = 11;
          filterObj.regionType = 11;
          filterObj.dashboardRegionType = 11
          handleAPICallAccordingToFilterShowpieGraph(filterObj)
        }

      }

      dispatch(
        fetchDistrictDataByStateCode({
          state_code: state_code,
          yearId: filterObj.yearId,
        })
      );
      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(state_name);

      const disObj = {
        stateId: state_code,
        state_name: state_name,
        latitude: long,
        longitude: lat,
      };

      sessionStorage.setItem("state-map-details", JSON.stringify(disObj));
      dispatch(updateMapSession(disObj));
      dispatch(handleShowDistrict(true));
    }

    dispatch(updateFilterState(stateDataClone.data));
    window.localStorage.setItem("state", state_name);
    window.localStorage.setItem("map_state_name", state_name);
    window.localStorage.setItem("map_district_name", "District");
    dispatch(handleCurrentIndex(0));
    hideOpendFilterBox();
  };

  const handleSchoolFilterDistrict = (e) => {
    const splittedArr = e.split("@");
    const district_code = splittedArr[0];
    const district_name = splittedArr[1];
    filterObj.yearId = updateYearId;
    dispatch(handleRegionName("Districts"));
    dispatch(updateUdiseBlockCode(district_code));
    if (district_name === districtWiseName) {
      filterObj.regionType = allDWiseregionType;
      filterObj.regionCode = district_code;
      filterObj.dashboardRegionType = 22;
      filterObj.dashboardRegionCode = "09";
      filterObj.dType = allDWiseregionType;
      filterObj.dCode = district_code;
      if (location.pathname !== "/") {
        filterObj.valueType = 1;
      } else {
        filterObj.valueType = 2;
      }

      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: allDWiseregionType,
        regionCode: district_code,
        dashboardRegionType: 22,
        dashboardRegionCode: "09",
        dType: allDWiseregionType,
        dCode: district_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        yearId: filterObj.yearId,
      };
      
      dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      handleAPICallAccordingToFilterShow(filterObj);
      dispatch(removeAllBlock());
      setSelectedBlockClone(block);
      // setSelectedBlock(block_name);
    } else {
      filterObj.regionType = specificDWiseregionType;
      filterObj.regionCode = district_code;
      filterObj.dashboardRegionType = 12;
      filterObj.dashboardRegionCode = district_code;
      filterObj.dType = specificDWiseregionType;
      filterObj.dCode = district_code;
      if (location.pathname !== "/") {
        filterObj.valueType = 1;
      } else {
        filterObj.valueType = 2;
      }

      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: specificDWiseregionType,
        regionCode: district_code,
        dashboardRegionType: 12,
        dashboardRegionCode: district_code,
        dType: specificDWiseregionType,
        dCode: district_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        yearId: filterObj.yearId,
      };

      // filterObj.dashboardRegionCode = district_code;
      dispatch(
        fetchBlockByDistrictCode({
          district_code: district_code,
          yearId: filterObj.yearId,
        })
      );
      dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      setSelectedBlockClone(district_name);
      handleAPICallAccordingToFilter(filterObj);
      headerData.isViewDataByShow &&
        handleAPICallAccordingToFilterShow(filterObj);
      /*this function will be called when chart tab selected*/
      if (
        !headerData.isViewDataByShow &&
        location.pathname !== "/" &&
        location.pathname !== "/school-reports-1005" &&
        location.pathname !== "/school-reports-1003" &&
        location.pathname !== "/school-reports-1004"
      ) {
        const block_data = district_code + "@" + blockWiseName;
        handleSchoolFilterBlock(block_data);
        if (location.pathname === "/infrastructure-reports3013") {
          filterObj.dCode = 12;
          filterObj.regionType = 12;
          filterObj.dashboardRegionType = 12
          handleAPICallAccordingToFilterShowpieGraph(filterObj)
        }
      }
    }
    dispatch(updateFilterDistrict(districtDataClone.data));
    dispatch(removeAllBlock());
    setSelectedDistrict(district_name);
    setSelectedBlock(block);
    setSelectedBlockClone(block);
    window.localStorage.setItem("map_district_name", district_name);
    window.localStorage.setItem("district", district_name);
    dispatch(handleCurrentIndex(0));

    hideOpendFilterBox();
  };

  const handleSchoolFilterBlock = (e) => {
    const splittedArr = e.split("@");
    const block_code = splittedArr[0];
    const block_name = splittedArr[1];
    filterObj.yearId = updateYearId;
    dispatch(handleRegionName("Blocks"));
    if (block_name === blockWiseName) {
      filterObj.regionType = allBWiseregionType;
      filterObj.regionCode = block_code;
      filterObj.dType = allBWiseregionType;
      filterObj.dCode = block_code;
      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: allBWiseregionType,
        regionCode: block_code,
        dType: allBWiseregionType,
        dCode: block_code,
        yearId: filterObj.yearId,
      };

      dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      handleAPICallAccordingToFilterShow(filterObj);
      handleAPICallAccordingToFilterShowpieGraph(filterObj)
    } else {
      filterObj.regionType = specificBWiseregionType;
      filterObj.regionCode = block_code;
      filterObj.dType = specificBWiseregionType;
      filterObj.dCode = block_code;

      const updatedFilterObj = {
        categoryCode: 0,
        locationCode: 0,
        managementCode: 0,
        schoolTypeCode: 0,
        regionType: specificBWiseregionType,
        regionCode: block_code,
        dType: specificBWiseregionType,
        dCode: block_code,
        yearId: filterObj.yearId,
      };
      dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      handleAPICallAccordingToFilterShow(filterObj);
      handleAPICallAccordingToFilterShowpieGraph(filterObj)
    }
    dispatch(updateFilterBlock(blockDataClone.data));
    setSelectedBlock(block_name);
    setSelectedBlock(block);
    setSelectedBlockClone(block);
    window.localStorage.setItem("block", block_name);
    dispatch(handleCurrentIndex(0));

    hideOpendFilterBox();
  };

  /*----------Call API According to Filter-----------*/
  const handleAPICallAccordingToFilter = (obj) => {
    //console.log('location.pathname', location.pathname)
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" || location.pathname === "/school-reports-1004" ) &&
      headerData.activeTab === "graph"
    ) {
      obj.valueType = 2;
      dispatch(fetchSchoolStatsData(obj));
      obj.valueType = 1;
      dispatch(fetchSchoolStatsDataYear(obj));
    }

    if (
      (location.pathname === "/school-reports-1006")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:1}));
    }

    if (
      (location.pathname === "/school-reports-1007")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:2}));
    }
    if (
      (location.pathname === "/school-reports-1008")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:3}));
    }
    if (
      (location.pathname === "/school-reports-1009")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:4}));
    }
    if (
      (location.pathname === "/school-reports-1010")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:5}));
    }
    if (
      (location.pathname === "/school-reports-1011")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:6}));
    }
    if (
      (location.pathname === "/school-reports-1013")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:7}));
    }
    if (
      (location.pathname === "/school-reports-1014")
    ) {
      dispatch(fetchArchiveServicesProfileSchoolData({...obj, itemGroupId:1, itemId:8}));
    }

    if (location.pathname === "/teacher-reports-2008") {
      dispatch(fetchArchiveServicesTeacherDataSocialCatGender(obj));
    }
    if (location.pathname === "/teacher-reports-2009") {
      dispatch(fetchArchiveServicesTeacherDisabilityData(obj));
    }
    if (location.pathname === "/teacher-reports-2003") {
      dispatch(fetchArchiveServicesClassesTaughtData({...obj, itemGroupId:1, itemId: 0}));
    }
    if (location.pathname === "/teacher-reports-2004") {
      dispatch(fetchArchiveServicesClassesTaughtData({...obj, itemGroupId:2, itemId: 0}));
    }
    if (location.pathname === "/teacher-reports-2005") {
      dispatch(fetchArchiveServicesClassesTaughtData({...obj, itemGroupId:5, itemId: 1}));
    }
    if (location.pathname === "/teacher-reports-2006") {
      dispatch(fetchArchiveServicesClassesTaughtData({...obj, itemGroupId:6}));
    }
    if (location.pathname === "/teacher-reports-2007") {
      dispatch(fetchArchiveServicesPtRYearsManagementWise(obj));
    }
    if (location.pathname === "/teacher-reports-2002" || location.pathname === "/teacher-reports-2010" || location.pathname === "/teacher-reports-2001") {
      dispatch(fetchArchiveServicesTeacherData(obj));
     
    }

    if(location.pathname === "/teacher-reports-2001"){
      dispatch(fetchTeachersStatsData({...obj, removeYearId: true}));
    }

    if (location.pathname === "/teacher-reports-2011") {
      dispatch(fetchArchiveServicesTeacherTrainingData(obj));
    }
    if (location.pathname === "/student-reports-4000" || location.pathname === "/student-reports-4002" || location.pathname === "/student-reports-4004" 
        || location.pathname === "/student-reports-4006" || location.pathname === "/student-reports-4008" || location.pathname === "/student-reports-4009") {
      dispatch(fetchArchiveServicesStudentData(obj));
      dispatch(fetchStudentStatsIntData(obj));
      dispatch(fetchStudentStatsData({...obj, removeYearId: true}));
      
    }

    if (location.pathname === "/student-reports-4007") {
      dispatch(fetchArchiveServicesCWSNEnrolmentData(obj));
    }

    if (location.pathname === "/student-reports-4010") {
      ////console.log('object payload', obj);
      ////console.log('object payload', activeCatTab4010);
      if(!obj.hasOwnProperty('itemGroupId')) obj['itemGroupId']= 6;
      if(activeCatTab4010 === 'All') dispatch(fetchArchiveServicesStudentSummarisedData(obj));
      else if(activeCatTab4010 === 'SC') dispatch(fetchArchiveServicesStudentSummarisedData({...obj, itemId:2}));
      else if(activeCatTab4010 === 'ST') dispatch(fetchArchiveServicesStudentSummarisedData({...obj, itemId:3}));      
    }

    if(location.pathname === "/student-reports-4011"){
      dispatch(fetchArchiveServicesStudentSummarisedData({...obj,itemGroupId: 7}))
    }

    if (location.pathname === "/student-reports-4032") {
      dispatch(fetchArchiveServicesStudentGPIStatsData(obj));
    }
    if (location.pathname !== "/") {
      dispatch(fetchArchiveServicesSchoolData(obj));
    }

  };

  /*.......Call API According to filter when select paticular state then all district show.....*/
  const handleAPICallAccordingToFilterShow = (obj) => {
    if (location.pathname !== "/") {
      dispatch(fetchArchiveServicesSchoolData(obj));
    }

  };

  const handleAPICallAccordingToFilterShowpieGraph = (obj) => {
    if (location.pathname === "/infrastructure-reports3013") {
      dispatch(fetchArchiveServicesPieGraphSchoolData(obj));
    }
  };
  /*-------------------end here----------------------*/

  /*------------Dropdown List----------------*/

  const districtDropdownOptions = () => {
    let extra_col;
    if (districtData.data && districtData.data.data) {
      extra_col = JSON.parse(JSON.stringify(districtData?.data?.data));
    } else {
      extra_col = [];
    }
    if (selectedDistrictclone !== district) {
      extra_col.unshift({
        udiseDistrictCode: distBlockWiseData.districtUdiseCode,
        udiseDistrictName: "District Wise",
      });
    }
    // hide District Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" || location.pathname === "/school-reports-1004" ||
        location.pathname === "/infrastructure-reports3013" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      if (selectedDistrictclone !== district) {
        extra_col.shift({
          udiseDistrictCode: distBlockWiseData.districtUdiseCode,
          udiseDistrictName: "District Wise",
        });
      }
    }
    if (location.pathname === "/") {
      if (selectedDistrictclone !== district) {
        extra_col.shift({
          udiseDistrictCode: distBlockWiseData.districtUdiseCode,
          udiseDistrictName: "District Wise",
        });
      }
    }
    return extra_col;
  };
  const blockDropdownOptions = () => {
    let extra_col;
    if (blockData.data && blockData.data.data) {
      extra_col = JSON.parse(JSON.stringify(blockData.data.data));
    } else {
      extra_col = [];
    }
    if (selectedBlockClone === block) {
      extra_col.unshift({
        udiseBlockCode: distBlockWiseData.blockUdiseCode,
        udiseBlockName: "Block Wise",
      });
    }
    // hide Block Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" ||
        location.pathname === "/school-reports-1004" ||
        location.pathname === "/infrastructure-reports3013" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      if (selectedBlockClone === block) {
        extra_col.shift({
          udiseBlockCode: distBlockWiseData.blockUdiseCode,
          udiseBlockName: "Block Wise",
        });
      }
    }
    if (location.pathname === "/") {
      if (selectedBlockClone !== block) {
        extra_col.shift({
          udiseBlockCode: distBlockWiseData.blockUdiseCode,
          udiseBlockName: "Block Wise",
        });
      }
    }
    return extra_col;
  };
  /*-------------End Here----------------*/
  const hideOpendFilterBox = () => {
    const boxes = document.querySelectorAll(".dropdown-menu");
    boxes.forEach((box) => {
      box.classList.remove("show");
    });
  };
  // const [show, setShow] = useState(false);

  const stateDropdownOptions = () => {
    let extra_col = [];

    if (stateData?.data && stateData?.data?.data) {
      extra_col = JSON.parse(JSON.stringify(stateData?.data?.data));

      if (jsonstateData && jsonstateData.length > 0) {
        extra_col?.forEach((state) => {
          const matchedState = jsonstateData.find(
            (data) => data?.udiseStateCode === state?.udiseStateCode
          );
          if (matchedState) {
            state.latitude = matchedState?.latitude;
            state.longitude = matchedState?.longitude;
          }
        });
      }
    }

    extra_col.unshift({
      udiseStateCode: allSWiseregionType.toString(),
      udiseStateName: stateWiseName,
    });

    // hide State Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" ||
        location.pathname === "/school-reports-1004" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      extra_col.shift({
        udiseStateCode: allSWiseregionType.toString(),
        udiseStateName: stateWiseName,
      });
    }
    if (location.pathname === "/") {
      extra_col.shift({
        udiseStateCode: allSWiseregionType.toString(),
        udiseStateName: stateWiseName,
      });
    }
    extra_col.unshift({
      udiseStateCode: nWiseregionType.toString(),
      udiseStateName: nationalWiseName,
    });


    return extra_col;
  };

  const handleReset3016 = () => {

    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
    setSelectedYear("2024-25");
    setSelectedBlock(block);
    setIsStateSelected(false);
    dispatch(handleRegionName("States"));
    // filterObj.regionCode = 99;
    // filterObj.yearId = 10;
    const modifyobject = {
      categoryCode: 0,
      dashboardRegionCode: 11,
      dashboardRegionType: 11,
      locationCode: 0,
      managementCode: 0,
      regionCode: 99,
      // regionCode: filterObj.regionCode,
      regionType: 10,
      dType: 10, //21statewise //10 for all india change 21 to 10
      dCode: 99, // 11statewise //99 for all india change 11 to 99
      schoolTypeCode: 0,
      // yearId: filterObj.yearId,
      yearId:10
    };

    setUpdateYearId(filterObj?.yearId);
    dispatch(allFilter(modifyobject));
    if (location.pathname === "/infrastructure-reports3013") {
      if (headerData.activeTab === "table") {
        window.localStorage.setItem("state", "All India/National");
        window.localStorage.setItem("map_state_name", "All India/National");
        window.localStorage.setItem("map_district_name", "District");
        window.localStorage.setItem("district", "District");
        window.localStorage.setItem("block", "Block");
        handleAPICallAccordingToFilter(modifyobject);
      }
      else if (headerData.activeTab === "graph") {
        window.localStorage.setItem("state", "State Wise");
        window.localStorage.setItem("map_state_name", "State Wise");
        window.localStorage.setItem("map_district_name", "District");
        window.localStorage.setItem("district", "District");
        window.localStorage.setItem("block", "Block");
        handleAPICallAccordingToFilter(intialStateWiseFilterSchData);
        handleAPICallAccordingToFilterShowpieGraph(modifyobject)
      }
    } else {
      if (headerData.activeTab === "table") {
        window.localStorage.setItem("state", "All India/National");
        window.localStorage.setItem("map_state_name", "All India/National");
        window.localStorage.setItem("map_district_name", "District");
        window.localStorage.setItem("district", "District");
        window.localStorage.setItem("block", "Block");
        handleAPICallAccordingToFilter(modifyobject);
      }

    }

    //handleAPICallAccordingToFilterShow(modifyobject);

    dispatch(handleCurrentIndex(0));
    // window.localStorage.setItem("state_wise", "All India/National");

  };

  useEffect(() => {
    setSelectedState(selectedState);
  }, [selectedState]);
  useEffect(() => {

    if (mapStateValue === "All India/National" && selectedYear === "2021-22") {
      setIsDashbtnDisabled(true);
    } else {
      setIsDashbtnDisabled(false);
    }

  }, [mapStateValue, selectedYear]);
  useEffect(() => {
    // if((location.pathname === "/teacher-reports-2008" || location.pathname === "/school-reports-1005" || location.pathname === "/school-reports-1003")){
    //   if (mapStateValue === "All India/National" && selectedYear === "2021-22") {
    //     setIs3016btnDisabled(true);
    //   } else {
    //     setIs3016btnDisabled(true);
    //   }
    // } 
    if (location.pathname === "/infrastructure-reports3013") {
      if (headerData.activeTab === "table") {
        if (mapStateValue === "All India/National" && selectedYear === "2021-22") {
          setIs3016btnDisabled(true);
        } else {
          setIs3016btnDisabled(false);
        }
      }
      else {
        if (mapStateValue === "State Wise" && selectedYear === "2021-22") {
          setIs3016btnDisabled(true);
        } else {
          setIs3016btnDisabled(false);
        }
      }
    }
    else {
      if (mapStateValue === "All India/National" && selectedYear === "2021-22") {
        setIs3016btnDisabled(true);
      } else {
        setIs3016btnDisabled(false);
      }
    }
  }, [mapStateValue, selectedYear, headerSlice.activeTab, location.pathname]);

  return (
    <>
      <div
        className="Side_filter"
        onClick={() => dispatch(handleShowFilter(!show))}
      >
        <div className="open-btn">
          {!show ? (
            <span className="material-icons-round">sort</span>
          ) : (
            <span className="material-icons-round">expand_more</span>
          )}
        </div>
      </div>
      <div
        className={`custmize-filter-column ${show ? "show" : ""}`}
        id="customize_filter"
      >
        <div className="search-f-box">
          <div className="heading-sm main-title d-flex align-items-center">
            <span className="material-icons-round text-blue me-3">sort</span>{" "}
            Apply Filters
          </div>
          <div className="box-cont-cust">
            <div className="search-box-div mb-3">
              <span className="select-lable-title">Select Year</span>
              <Select
                mode="single"
                showSearch={true}
                id="year-id"
                placeholder={selectedYear}
                value={mapYearValue}
                onChange={handleSchoolFilterYear}
                style={{
                  width: "100%",
                }}
                options={yearData?.data?.data.map((item) => ({
                  value: item.yearId + "@" + item.yearDesc,
                  label: item.yearDesc,
                }))}
              />
            </div>
            <div className="search-box-div mb-3">
              <span className="select-lable-title">Select State</span>
              <Select
                mode="single"
                showSearch={true}
                placeholder={selectedState || "Select a state"}
                value={mapStateValue}
                onChange={handleSchoolFilterState}
                id="school_state"
                name="map_state_name"
                style={{
                  width: "100%",
                }}
                options={stateDropdownOptions().map((item) => ({
                  value:
                    item.udiseStateCode +
                    "@" +
                    item.udiseStateName +
                    "@" +
                    item.longitude +
                    "@" +
                    item.latitude,
                  label: item.udiseStateName,
                }))}
              />
            </div>
              {/* <div className="search-box-div mb-3">
                <span className="select-lable-title">Select District</span>
                <Select
                  mode="single"
                  showSearch={true}
                  placeholder={selectedDistrict || "Select a district"}
                  value={mapDisValue}
                  onChange={handleSchoolFilterDistrict}
                  name="map_district_name"
                  style={{
                    width: "100%",
                  }}
                  options={districtDropdownOptions().map((item) => ({
                    value:
                      item.udiseDistrictCode + "@" + item.udiseDistrictName,
                    label: item.udiseDistrictName,
                  }))}
                  disabled={!isStateSelected}
                />
              </div> */}

            {/* {location.pathname !== "/" && (
              <div className="search-box-div">
                <span className="select-lable-title">Select Block</span>
                <Select
                  mode="single"
                  showSearch={true}
                  placeholder={selectedBlock}
                  value={mapBlockValue}
                  onChange={handleSchoolFilterBlock}
                  name="block"
                  style={{
                    width: "100%",
                  }}
                  options={blockDropdownOptions().map((item) => ({
                    value: item.udiseBlockCode + "@" + item.udiseBlockName,
                    label: item.udiseBlockName,
                  }))}
                />
              </div>
            )} */}
            <div className="text-center mt-2">
              <button
                className="btn btn-primary btn-reset-filter"
                disabled={is3016btnDisabled}
                onClick={handleReset3016}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
